import React, { useState, useEffect } from 'react';
import './index.scss';
import classNames from 'classnames';
import { useRequest, useUnmount } from 'ahooks';
import { EnvironmentApi, Equipment, Logistics } from '@/api/request';
import { searchParams } from '@/utils';
import Loading from '@/components/loading/loading';
import _ from 'lodash';
import { BorderBox9, BorderBox4, Decoration10, BorderBox6, Decoration2, DigitalFlop, BorderBox2, Decoration9, BorderBox7 } from '@jiaminghi/data-view-react';
import Icon from '@/components/icon/icon';
import Header from '@/components/header';
import { store } from '@/store'
import { formatHours } from '@/utils/time';
import { useHistory } from 'react-router'

const lineCode = searchParams().lineCode;
const type = searchParams().type;
let content = <Loading />;
let firstEntry = true;

const handleCardData = (data: any, key: string) => {
    if (!Array.isArray(data)) return null
    if (data.length === 0) return null
    if (!data[0][key] && data[0][key] !== 0) return null
    return Math.floor(data[0][key])
}

const handleArrayToObject = (data: any, target: string) => {
    let result: any = {}
    data.forEach((item: any, index: number) => {
        item.originalPosition = index;
        result[item[target]] = item;
    });
    return result
}

//数组按对象里的属性排序
const handleArraySort = (propertyName: any) => {
    return function (obj1, obj2) {
        var value1 = obj1[propertyName];
        var value2 = obj2[propertyName];
        if (value1 < value2) {
            return -1
        } else if (value1 > value2) {
            return 1
        } else {
            return 0
        }
    }
}

//处理null数据
const handleNull = (data: null) => {
    return data === null ? '--' : data;
}

function IOTUpgrade() {
    const history = useHistory();
    let time: NodeJS.Timeout;
    const buttonData = ['烘箱', '胶罐', '机械手', '物流'];
    const typeData = ['ovenOrRefrigerator', 'glueBucket', 'robot', 'logistics',];
    const [timeData, setTimeData] = useState(0);
    //机械手状态: '初始化', '伺服关闭', '伺服开启', '戒备状态', '紧急停止', '急停恢复', '系统失效', '未知'
    const [buttonSelected, setButtonSelected] = useState({
        0: true,
        1: false,
        2: false,
        3: false,
    });
    const [meter, setMeter] = useState(0);
    const [rotation, setRotation] = useState(true);

    const handleButtonClick = (index: number) => {
        let selectedTem = buttonSelected;
        selectedTem[index] = !selectedTem[index];
        setButtonSelected({ ...selectedTem });
        setRotation(false);
        // console.log('selectedTem', selectedTem);
        history.push(`/iotUpgrade?lineCode=${lineCode}&type=${selectedTem[0] ? 'ovenOrRefrigerator%' : ''}${selectedTem[1] ? 'glueBucket%' : ''}${selectedTem[2] ? 'robot%' : ''}${selectedTem[3] ? 'logistics%' : ''}`);
    }

    const handleRotation = () => {
        // setRotation(!rotation);
        history.push(`/iotUpgrade?lineCode=${lineCode}&type`);
        setRotation(true);
        setButtonSelected({
            0: true,
            1: false,
            2: false,
            3: false,
        });
    }

    const formatter = (number) => {
        const numbers = number.toString().split('').reverse()
        const segs = []

        while (numbers.length) segs.push(numbers.splice(0, 3).join(''))

        return segs.join(',').split('').reverse().join('')
    }

    useEffect(() => {
        // console.log('type', type);
        if (!!type) {
            setRotation(false);
            setButtonSelected({
                0: type.indexOf('ovenOrRefrigerator') > -1,
                1: type.indexOf('glueBucket') > -1,
                2: type.indexOf('robot') > -1,
                3: type.indexOf('logistics') > -1,
            })
        }
    }, [])

    useEffect(() => {
        if (rotation) {
            time = setInterval(() => {
                let selectedTem = {
                    0: false,
                    1: false,
                    2: false,
                    3: false,
                };
                selectedTem[meter] = true;
                setButtonSelected({ ...selectedTem });
                setMeter(meter => (meter + 1) % 4);
            }, 1000 * 10)
        }
        return () => {
            if (time) {
                clearInterval(time);
            }
        }
    }, [rotation, meter])

    useUnmount(() => {
        firstEntry = true;
    })

    let { data, loading, error } = useRequest(() => {
        return Promise.all([
            EnvironmentApi.getCurrentEnvironmentValues(lineCode),
            Equipment.getCurrentElectricityPowerInW(lineCode),
            Equipment.getTodayElectricityQuantityInKWH(lineCode),
            Equipment.getTotalElectricityQuantityInKWH(lineCode),
            Equipment.getLineCurrentElectricities(lineCode),
            Equipment.getGlueBucketCurrentParameters(lineCode),
            Equipment.getOvensCurrentParameters(lineCode),
            Equipment.getRobotCurrentStatuses(lineCode),
            Logistics.getWorkstationCurrentPalletCounts(lineCode),
            Logistics.getStatisticValuesByWorkStation(lineCode)
        ])
    }, { pollingInterval: 1000 * 10 })

    let ovenData, rubberTankData, robotData, lineEnergyData, environmentData, power, logistics, logisticsArr, logisticsAnalysis;

    ovenData = [
        {
            code: '1',
            top: 100,
            left: 780,
            content: [null, null],
        },
        {
            code: '2',
            top: 100,
            left: 615,
            content: [null, null],
        },
        {
            code: '3',
            top: 100,
            left: 540,
            content: [null, null],
        },
        {
            code: '4',
            top: 70,
            left: 330,
            content: [null, null],
        },
        {
            code: '5',
            top: 470,
            left: 415,
            content: [null, null],
        },
        {
            code: '6',
            top: 470,
            left: 750,
            content: [null, null],
        },
        {
            code: '7',
            top: 470,
            left: 850,
            content: [null, null],
        },
        {
            code: '8',
            top: 350,
            left: 1100,
            content: [null, null],
        },
        {
            code: '9',
            top: 650,
            left: 750,
            content: [null, null],
        },
        {
            code: '10',
            top: 650,
            left: 850,
            content: [null, null],
        },
    ];
    rubberTankData = [
        {
            code: "1",
            top: 330,
            left: 190,
            content: [null, null],
        },
        {
            code: "2",
            top: 330,
            left: 330,
            content: [null, null],
        },
        {
            code: "3",
            top: 330,
            left: 510,
            content: [null, null],
        },
        {
            code: "4",
            top: 330,
            left: 650,
            content: [null, null],
        },
        {
            code: "5",
            top: 710,
            left: 295,
            content: [null, null],
        },
        {
            code: "6",
            top: 710,
            left: 510,
            content: [null, null],
        },
    ];
    robotData = [
        {
            code: "1",
            top: 326,
            left: 150,
            content: null,
        },
        {
            code: "2",
            top: 396,
            left: 150,
            content: null,
        },
        {
            code: "3",
            top: 470,
            left: 150,
            content: null,
        },
        {
            code: "4",
            top: 500,
            left: 212,
            content: null,
        },
        {
            code: "5",
            top: 500,
            left: 294,
            content: null,
        },
        {
            code: "6",
            top: 500,
            left: 525,
            content: null,
        },
        {
            code: "7",
            top: 500,
            left: 610,
            content: null,
        },
        {
            code: "8",
            top: 660,
            left: 348,
            content: null,
        },
        {
            code: "9",
            top: 660,
            left: 555,
            content: null,
        },
    ];
    lineEnergyData = [
        {
            title: '当前功率',
            content: null,
            unit: 'kW',
        },
        {
            title: '今日能耗',
            content: null,
            unit: '度',
        },
        {
            title: '累积能耗',
            content: null,
            unit: '万度',
        }
    ];
    environmentData = [
        {
            title: '温度',
            content: null,
            unit: '℃',
        },
        {
            title: '湿度',
            content: null,
            unit: '%',
        },
        {
            title: '噪音',
            content: null,
            unit: 'dB',
        },
        {
            title: 'PM2.5',
            content: null,
            unit: 'ug/m³',
        }
    ];
    power = [
        {
            title: 'A相',
            content: [null, null],
        },
        {
            title: 'B相',
            content: [null, null],
        },
        {
            title: 'C相',
            content: [null, null],
        },
    ];
    logistics = {
        'D1': [
            {
                code: "1",
                top: 280,
                left: 55,
                isFull: false,
            },
            {
                code: "2",
                top: 360,
                left: 55,
                isFull: false,
            },
            {
                code: "3",
                top: 435,
                left: 55,
                isFull: false,
            },
            {
                code: "4",
                top: 590,
                left: 190,
                isFull: false,
            },
            {
                code: "5",
                top: 590,
                left: 280,
                isFull: false,
            },
            {
                code: "6",
                top: 590,
                left: 425,
                isFull: false,
            },
            {
                code: "7",
                top: 590,
                left: 580,
                isFull: false,
            },
            {
                code: "8",
                top: 590,
                left: 660,
                isFull: false,
            },
            {
                code: "9",
                top: 590,
                left: 800,
                isFull: false,
            },
            {
                code: "10",
                top: 590,
                left: 980,
                isFull: false,
            },
            {
                code: "11",
                top: 520,
                left: 1200,
                isFull: false,
            },
            {
                code: "12",
                top: 370,
                left: 1200,
                isFull: false,
            },
            {
                code: "13",
                top: 250,
                left: 1200,
                isFull: false,
            },
            {
                code: "16",
                top: 200,
                left: 1050,
                isFull: false,
            },
            {
                code: "18",
                top: 200,
                left: 960,
                isFull: false,
            },
            {
                code: "14",
                top: 200,
                left: 880,
                isFull: false,
            },
            {
                code: "15",
                top: 200,
                left: 790,
                isFull: false,
            },
            {
                code: "19",
                top: 200,
                left: 700,
                isFull: false,
            },
            {
                code: "17",
                top: 200,
                left: 600,
                isFull: false,
            },
        ],
        'D2': [
            {
                code: "1",
                top: 280,
                left: 55,
                isFull: false,
            },
            {
                code: "2",
                top: 360,
                left: 55,
                isFull: false,
            },
            {
                code: "3",
                top: 435,
                left: 55,
                isFull: false,
            },
            {
                code: "4",
                top: 590,
                left: 190,
                isFull: false,
            },
            {
                code: "5",
                top: 590,
                left: 280,
                isFull: false,
            },
            {
                code: "6",
                top: 590,
                left: 425,
                isFull: false,
            },
            {
                code: "7",
                top: 590,
                left: 580,
                isFull: false,
            },
            {
                code: "8",
                top: 590,
                left: 660,
                isFull: false,
            },
            {
                code: "9",
                top: 590,
                left: 800,
                isFull: false,
            },
            {
                code: "10",
                top: 370,
                left: 1200,
                isFull: false,
            },
            {
                code: "11",
                top: 250,
                left: 1200,
                isFull: false,
            }
        ]
    }
    logisticsArr = [];
    logisticsAnalysis = {};

    if (!error && (!loading || !firstEntry)) {
        // if (false) {
        firstEntry = false;
        let [currentEnvironmentValues, currentElectricityPowerInW, todayElectricityQuantityInKWH, totalElectricityQuantityInKWH, lineCurrentElectricities, glueBucketCurrentParameters, ovensCurrentParameters, robotCurrentStatuses, workstationCurrentPalletCounts, statisticValuesByWorkStation]: any = data;
        ovenData.forEach((item: any) => {
            let temporary = handleArrayToObject(ovensCurrentParameters, 'ovenCode')[item.code];
            if (temporary) {
                item.content[0] = (!temporary.temperatureInC ? temporary.temperatureInC : Math.floor(temporary.temperatureInC * 10) / 10);
                item.content[1] = (!temporary.powerInW ? Number(temporary.powerInW) : Math.floor(temporary.powerInW / 1000 * 10) / 10);
            }
        });
        glueBucketCurrentParameters.forEach((item: any, index: number) => {
            rubberTankData[index].content[0] = (!item.positionInMillimeter ? item.positionInMillimeter : Math.floor(item.positionInMillimeter));
            rubberTankData[index].content[1] = (!item.positionInMillimeter ? item.positionInMillimeter : Math.floor(item.pressureInPa / 1000000 * 100) / 100);
        });
        rubberTankData.forEach((item: any) => {
            let temporary = handleArrayToObject(glueBucketCurrentParameters, 'bucketCode')[item.code];
            if (temporary) {
                item.content[0] = (!temporary.positionInMillimeter ? temporary.positionInMillimeter : Math.floor(temporary.positionInMillimeter));
                item.content[1] = (!temporary.positionInMillimeter ? temporary.positionInMillimeter : Math.floor(temporary.pressureInPa / 1000000 * 100) / 100);
            }
        });
        robotData.forEach((item: any) => {
            let temporary = handleArrayToObject(robotCurrentStatuses, 'workStationCode')[item.code];
            if (temporary) {
                item.content = !temporary.controllerState ? temporary.controllerState : temporary.controllerState;
            }
        });
        lineEnergyData = [
            {
                title: '当前功率',
                content: !currentElectricityPowerInW ? currentElectricityPowerInW : Math.floor(currentElectricityPowerInW / 1000 * 100) / 100,
                unit: 'kW',
            },
            {
                title: '今日能耗',
                content: !todayElectricityQuantityInKWH ? todayElectricityQuantityInKWH : Math.floor(todayElectricityQuantityInKWH),
                unit: '度',
            },
            {
                title: '累积能耗',
                content: !totalElectricityQuantityInKWH ? totalElectricityQuantityInKWH :
                    Math.floor(totalElectricityQuantityInKWH) > 9999 ? _.round(totalElectricityQuantityInKWH / 10000, 1) : Math.floor(totalElectricityQuantityInKWH),
                unit: !totalElectricityQuantityInKWH ? '度' :
                    Math.floor(totalElectricityQuantityInKWH) > 9999 ? '万度' : '度',
            }
        ];
        environmentData = [
            {
                title: '温度',
                content: !currentEnvironmentValues.temperatureInC ? currentEnvironmentValues.temperatureInC : Math.floor(currentEnvironmentValues.temperatureInC * 10) / 10,
                unit: '℃',
            },
            {
                title: '湿度',
                content: !currentEnvironmentValues.humidness ? currentEnvironmentValues.humidness : Math.floor(currentEnvironmentValues.humidness * 100),
                unit: '%',
            },
            {
                title: '噪音',
                content: !currentEnvironmentValues.noiseIndB ? currentEnvironmentValues.noiseIndB : Math.floor(currentEnvironmentValues.noiseIndB * 10) / 10,
                unit: 'dB',
            },
            {
                title: 'PM2.5',
                content: !currentEnvironmentValues.pM25 ? currentEnvironmentValues.pM25 : Math.floor(currentEnvironmentValues.pM25 * 10) / 10,
                unit: 'ug/m³',
            }
        ];
        power = [
            {
                title: 'A相',
                content: [handleCardData(lineCurrentElectricities, 'voltageAInV'), handleCardData(lineCurrentElectricities, 'currentAInA')],
            },
            {
                title: 'B相',
                content: [handleCardData(lineCurrentElectricities, 'voltageBInV'), handleCardData(lineCurrentElectricities, 'currentBInA')],
            },
            {
                title: 'C相',
                content: [handleCardData(lineCurrentElectricities, 'voltageCInV'), handleCardData(lineCurrentElectricities, 'currentCInA')],
            },
        ];
        logisticsArr = statisticValuesByWorkStation.sort(handleArraySort('isFullHours')).reverse().slice(0, 3);
        if (logisticsArr[0].usedHours === 0) {
            logisticsArr = []
        } else {
            logisticsAnalysis = handleArrayToObject(logisticsArr, 'workStationCode');
        }
        logistics[store.getState().projectInfo.shortCode].forEach((item: any) => {
            let temporary = handleArrayToObject(workstationCurrentPalletCounts, 'workStationCode')[item.code];
            if (temporary) {
                item.isFull = !temporary.isFull ? false : true;
            }
        });
    }

    content =
        <div className='upgrade-iot-container'>
            {/* 头部 */}
            {/* <Header name={headerTitle} /> */}
            <div className='upgrade-iot-header'>
                <Header name={store.getState().projectInfo.name} />
            </div>
            {/* 内容 */}
            <div className='upgrade-iot-body'>
                {/* 左侧布局图 */}
                <div className='upgrade-iot-body-left'>
                    <BorderBox9 color={['#3F96A5', '#3F96A5']}>
                        {/* 按钮列表 */}
                        <div className='upgrade-iot-list'>
                            {buttonData.map((item: any, index: number) => {
                                return <div
                                    className={classNames({
                                        'button': true,
                                        'selected': buttonSelected[index],
                                    })}
                                    onClick={() => handleButtonClick(index)}
                                    key={index}
                                >{item}</div>
                            })}
                        </div>
                        <Decoration9 dur={rotation ? 3 : 0} color={['#3f96a547', '#3F96A5']} style={{ width: '70px', height: '70px', position: 'absolute', top: `20px`, right: `30px`, color: '#fff', cursor: 'pointer' }}><div
                            style={{ width: '70px', height: '70px', zIndex: 999, lineHeight: '70px', textAlign: 'center' }}
                            onClick={() => handleRotation()}
                        >{rotation ? '轮播中' : '轮播'}</div>
                        </Decoration9>
                        <Decoration10 color={['#3F96A5']} style={{ width: '100%', height: '5px', padding: '8px 25px 0' }} />
                        {/* 悬浮信息框 */}
                        <div className='upgrade-iot-illustration'>
                            {ovenData.map((item: any, index: number) => {
                                return (
                                    !handleArrayToObject(store.getState().ovenOrRefrigerators, 'code')[item.code] ?
                                        '' :
                                        <div key={index} style={{ width: '70px', height: '85px', position: 'absolute', backgroundColor: '#141414c4', top: `${item.top}px`, left: `${item.left}px`, transition: `opacity ${0.2 + 0.15 * index}s` }}
                                            className={classNames({
                                                'hideAnimation': true,
                                                'hideGraphical': !buttonSelected[0],
                                            })}
                                        >
                                            <BorderBox7 color={['#000', '#fff']}>
                                                <div className='oven'>
                                                    <div className='illustration-title'>{handleArrayToObject(store.getState().ovenOrRefrigerators, 'code')[item.code].name.replace(new RegExp("烘箱"), "")}</div>
                                                    <div className='illustration-data'><span className='number'>{handleNull(item.content[0])}</span>℃</div>
                                                    <div className='illustration-data'><span className='number'>{handleNull(item.content[1])}</span>kW</div>
                                                </div>
                                            </BorderBox7>
                                        </div>
                                )
                            })}
                            {robotData.map((item: any, index: number) => {
                                return (
                                    <div key={index} style={{ width: '30px', height: '30px', borderRadius: '15px', border: '4px solid #000', position: 'absolute', top: `${item.top}px`, left: `${item.left}px`, transition: `opacity ${0.2 + 0.15 * index}s` }}
                                        className={classNames({
                                            'hideAnimation': true,
                                            'hideGraphical': !buttonSelected[2],
                                            'show-off': item.content === null,
                                            'show-bad': item.content !== null,
                                            'show-normal': item.content === 3,
                                            'show-error': item.content === 5 || item.content === 7 || item.content === 8
                                        })}
                                    >
                                    </div>
                                )
                            })}
                            {rubberTankData.map((item: any, index: number) => {
                                return (
                                    <div key={index} style={{ width: '135px', height: '95px', position: 'absolute', top: `${item.top}px`, left: `${item.left}px`, backgroundColor: '#141414c4', transition: `opacity ${0.2 + 0.15 * index}s` }}
                                        className={classNames({
                                            'hideAnimation': true,
                                            'hideGraphical': !buttonSelected[1],
                                        })}
                                    >
                                        <BorderBox2>
                                            <div className='rubberTank'>
                                                <div className='illustration-title'>{handleArrayToObject(store.getState().glueBuckets, 'code')[item.code].name}</div>
                                                <div className='illustration-data'>液位: <span className='number'>{handleNull(item.content[0])}</span>mm</div>
                                                <div className='illustration-data'>压力: <span className='number'>{handleNull(item.content[1])}</span>MPa</div>
                                            </div>
                                        </BorderBox2>
                                    </div>
                                )
                            })}
                            {logistics[store.getState().projectInfo.shortCode].map((item: any, index: number) => {
                                return (
                                    !handleArrayToObject(store.getState().hasStopperWorkStations, 'code')[item.code] ?
                                        '' :
                                        <div key={index} style={{ width: '40px', height: '40px', border: `4px solid ${!!logisticsAnalysis[item.code] ? '#d72323' : '#000'}`, position: 'absolute', top: `${item.top}px`, left: `${item.left}px`, transition: `opacity ${0.2 + 0.15 * index}s` }}
                                            className={classNames({
                                                'hideAnimation': true,
                                                'logistics': true,
                                                'hideGraphical': !buttonSelected[3],
                                                'show-error': item.isFull,
                                            })}
                                        >
                                            {logisticsAnalysis[item.code] ? logisticsAnalysis[item.code].originalPosition + 1 : ''}
                                        </div>
                                )
                            })}
                            <div className={classNames({
                                'hideAnimation logisticsRanking': true,
                                'hideGraphical': !buttonSelected[3],
                            })}>
                                <p>今日满料时长:</p>
                                {logisticsArr.map((item: any, index: number) => {
                                    return (
                                        <div className='logisticsRanking-list'>
                                            <div>No.{index + 1}</div>
                                            <div>{item.workStationName}</div>
                                            <div className='logisticsRanking-error'>{formatHours(item.isFullHours)}</div>
                                        </div>
                                    )
                                })}

                            </div>
                        </div>
                    </BorderBox9>
                </div>
                {/* 右侧信息 */}
                <div className='upgrade-iot-body-right'>
                    <BorderBox4 reverse="{true}" color={['#3F96A5', '#3F96A5']}>
                        <div className="right-container">
                            {/* 能耗 */}
                            <div className='right-card' style={{ height: '400px' }}>
                                <BorderBox6 color={['#3F96A5', '#3F96A5']}>
                                    <div className='card-title'>
                                        <div className='card-title-circle' style={{ backgroundColor: '#2f89fc' }}><Icon url={require('../../../assets/images/iot/power.svg')} size={1.4} /></div>
                                        能耗
                                    </div>
                                    <div className='card-content-column'>
                                        {lineEnergyData.map((item: any, index: any) => {
                                            return (
                                                <div className='column-modular' key={index}>
                                                    <div className='modular-title'>{item.title}</div>
                                                    <div className='modular-data'><DigitalFlop
                                                        config={{
                                                            textAlign: 'right',
                                                            style: { fontSize: 46 },
                                                            number: [item.content === null ? null : Number(item.content)],
                                                            content: `${item.content === null ? '--' : ''}{nt}`,
                                                            toFixed: `${index === 2 ? 1 : 0}`,
                                                            formatter
                                                        }}
                                                        style={{ width: `${index === 2 ? '98px' : '200px'}`, height: '55px' }} />{item.unit}</div>
                                                </div>
                                            )
                                        })}
                                    </div>

                                    <div className='card-content-column'>
                                        {power.map((item: any, index: any) => {
                                            return (
                                                <div className='column-modular' key={index} style={{ paddingTop: '15px' }}>
                                                    <div className='modular-title' >{item.title}</div>
                                                    <div className='modular-data' style={{ marginTop: '10px' }}><DigitalFlop
                                                        config={{
                                                            textAlign: 'right',
                                                            style: { fontSize: 40 },
                                                            number: [item.content[0] === null ? null : Number(item.content[0])],
                                                            content: `${item.content[0] === null ? '--' : ''}{nt}`,
                                                            formatter
                                                        }}
                                                        style={{ width: '108px', height: '45px' }} />V</div>
                                                    <div className='modular-data' style={{ marginTop: '5px' }}><DigitalFlop
                                                        config={{
                                                            textAlign: 'right',
                                                            style: { fontSize: 40 },
                                                            number: [item.content[1] === null ? null : Number(item.content[1])],
                                                            content: `${item.content[1] === null ? '--' : ''}{nt}`,
                                                            formatter
                                                        }}
                                                        style={{ width: '108px', height: '45px' }} />A</div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </BorderBox6>
                            </div>
                            <Decoration2 dur={10} style={{ width: '90%', height: '5px' }} />
                            {/* 环境 */}
                            <div className='right-card'>
                                <BorderBox6 color={['#3F96A5', '#3F96A5']}>
                                    <div className='card-title'>
                                        <div className='card-title-circle' style={{ backgroundColor: '#2cb978' }}><Icon url={require('../../../assets/images/iot/environment.svg')} size={1.4} /></div>
                                        环境
                                    </div>
                                    <div className='card-content-environment'>
                                        {environmentData.map((item: any, index: any) => {
                                            return (
                                                <div className='column-modular' key={index}>
                                                    <div className='modular-title'>{item.title}</div>
                                                    <div className='modular-data'><DigitalFlop
                                                        config={{
                                                            textAlign: 'right',
                                                            style: { fontSize: 46 },
                                                            number: [item.content === null ? null : Number(item.content)],
                                                            content: `${item.content === null ? '--' : ''}{nt}`,
                                                            formatter
                                                        }}
                                                        style={{ width: `${index === 3 ? '65px' : '120px'}`, height: '80px' }} />{item.unit}</div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </BorderBox6>
                            </div>
                        </div>
                    </BorderBox4>
                </div>
            </div>
        </div >
    return content;
}

export { IOTUpgrade }